import { Subscription } from '../../types/subscription'
import { getPaymentMethodV3 } from './getPaymentMethodV3'
import { getSubscriptions } from './getSubscriptions'

export interface GetCurrentSubscriptionOptions {
  token?: string
}

export const getCurrentSubscription = async (
  options: GetCurrentSubscriptionOptions
): Promise<Subscription | undefined | null> => {
  const data = await getSubscriptions({ ...options, filter: { isCurrent: true } })
  const subscription = data?.[0]

  if (subscription?.paymentMethodId) {
    const paymentMethod = await getPaymentMethodV3({
      token: options.token,
      paymentMethodId: subscription?.paymentMethodId
    })
    return {
      ...data?.[0],
      paymentMethod: paymentMethod
    }
  } else {
    return subscription || null
  }
}
